/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import { Web3Factory } from './factory';
export class Web3Injector {
    constructor(endpoint, options) {
        this.endpoint = endpoint;
        this.options = options;
    }
    inject(shouldOverwrite = false) {
        if (!shouldOverwrite && (window['web3'] || window['ethereum'])) {
            return;
        }
        const factory = new Web3Factory(this.endpoint, this.options);
        window['web3'] = factory.createWeb3();
        window['ethereum'] = factory.createEthereum();
    }
    static clear() {
        window['web3'] = undefined;
        window['ethereum'] = undefined;
    }
}
